<template>
  <div>
    <el-table
        ref="multipleTableRef"
        :data="pageDataList"
        style="width: 100%"
        border
        @cell-click="toggleSelection"
        v-loading="listLoading"
    >
      <el-table-column property="showDate" label="打招呼时间" />
      <el-table-column property="" label="接收方">
        <template #default="scope">
          <UserInfoList :row="scope.row" showList="name,phone,uid,city,birth" :isDialog="true"/>
        </template>
      </el-table-column>
      <el-table-column property="" label="招呼类型">
        <template #default="scope">
          <p>{{scope.row.greetingType == 2?'自动':'手动'}}</p>
        </template>
      </el-table-column>
      <el-table-column property="" label="招呼内容">
        <template #default="scope">
          <p>{{pageDataList[scope.$index].orderNum == 1?'第一句：':pageDataList[scope.$index].orderNum == 2?'第二句：':pageDataList[scope.$index].orderNum == 3?'第三句：':''}}{{ pageDataList[scope.$index].greetingMsg }}</p>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
    </el-pagination>
  </div>
</template>

<script>
import { getFormData } from '@/api/api'
import { getGreetingDateUserList } from '@/api/url'
import UserInfoList from "@/components/resume/UserInfoList";
export default {
  name: "GreetingDateNum",
  components: { UserInfoList },
  props: {
    value: Object
  },
  data() {
    return {
      userId: this.value.userId,
      type: this.value.type,
      showDate: this.value.showDate,

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,
      listLoading: false,
      searchLoading: false,

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getPage() {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['id'] = this.userId;
      param['type'] = this.type;
      param['showDate'] = this.showDate;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getGreetingDateUserList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {

    },

  },
  mounted() {
    this.getPage();
  }
}
</script>

<style scoped>

</style>
